import { Box } from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import _ from "lodash";

const useStyles = makeStyles((theme) => ({
    margin: {
        margin: theme.spacing(1),
    },
    group: {
        display: 'flex',
        alignItems: 'center'
    },
    item: {
        color: 'white'
    },
    formControl: {
        marginBottom: theme.spacing(1),
        minWidth: 220,

    },
    leftSection: {
        paddingTop: theme.spacing(3),
        display: 'flex',
        justifyContent: 'space-evenly',
        alignItems: 'left',
    },
    dialog: {
        overflow: 'auto',
        maxHeight: '60vh',
        '&::-webkit-scrollbar': {
            width: '7px',
            backgroundColor: 'lightgray',
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'gray',
            borderRadius: '4px',
            height: '60px'
        },
    }
}));

function KeyAccountTable(props) {
    const {handleNameClick} = props
    const { t } = useTranslation('incidentmanagement');
    const PAGE_SIZE = 20;

    const Column = [
        {
            field: 'name',
            headerName: t('name'),
            maxWidth: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.4,
            renderCell: (params) => (
                <div
                    style={{
                        cursor: 'pointer',
                        color: 'orange',
                        textDecoration: 'underline', // Add underline styling
                    }}
                    onClick={() => handleNameClick(params.row)} 
                >
                    {params.value}
                </div>
            ),
        },
        {
            field: 'email',
            headerName: t('email'),
            maxWidth: 100,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
        },
        {
            field: 'phone',
            headerName: t('phone'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
        },
        {
            field: 'ding_talk_id',
            headerName: t('ding_talk_id'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
        },
        {
            field: 'partners',
            headerName: t('partners'),
            width: 150,
            headerAlign: 'center',
            align: 'center',
            flex: 0.6,
        }
    ];

    const rows = Array.isArray(props.data)
        ? props.data.map((item, index) => ({
            id: item.id,  // Use the array index as the unique ID for each row
            name: item.name || '',
            email: item.email || '',
            phone: item.phone || '',
            ding_talk_id: item.ding_talk_id || '',
            partners: item.partners || '',
        }))
        : [];

    const [selectedItemId, setSelectedItemId] = useState(null);

    return (
        <Box style={{ margin: 30, paddingRight: 40 }}>
            <DataGrid
                columns={Column}
                rows={rows || []}
                pagination
                pageSize={PAGE_SIZE}
                rowsPerPageOptions={[PAGE_SIZE]}
                loading={props.isDataLoading}
                rowCount={rows?.length || 0}
                style={{ height: '75vh' }}
            />
        </Box>
    );
}

export default KeyAccountTable;